import { Controller } from "@hotwired/stimulus"

const DATE_FORMATTER = new Intl.DateTimeFormat("en-GB", {
  day: "2-digit",
  month: "short",
  year: "numeric",
})

export default class extends Controller {
  static targets = ["estimatedDate"]

  updateDuration(event) {
    const days = parseInt(event.target.value, 10)
    if (isNaN(days)) return

    const date = new Date()
    date.setDate(date.getDate() + days)
    this.estimatedDateTarget.textContent = DATE_FORMATTER.format(date)
  }
}
